var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsercircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 0.75C12.0312 0.75 15.5 4.21875 15.5 8.5C15.5 12.7812 12.0312 16.25 7.75 16.25C3.46875 16.25 0 12.7812 0 8.5C0 4.21875 3.46875 0.75 7.75 0.75ZM7.75 3.75C6.21875 3.75 5 5 5 6.5C5 8.03125 6.21875 9.25 7.75 9.25C9.25 9.25 10.5 8.03125 10.5 6.5C10.5 5 9.25 3.75 7.75 3.75ZM7.75 14.5C9.5625 14.5 11.2188 13.6875 12.3125 12.375C11.7188 11.2812 10.5625 10.5 9.25 10.5C9.15625 10.5 9.09375 10.5312 9 10.5625C8.625 10.6875 8.1875 10.75 7.75 10.75C7.28125 10.75 6.875 10.6875 6.46875 10.5625C6.375 10.5312 6.3125 10.5 6.25 10.5C4.90625 10.5 3.75 11.2812 3.15625 12.375C4.25 13.6875 5.90625 14.5 7.75 14.5Z",
    fill: "#343435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsercircle);
export default __webpack_public_path__ + "static/media/Usercircle.c471a9a7fbf3660da93d08205ea8e868.svg";
export { ForwardRef as ReactComponent };